import { AdminApiService } from '../services';
import type { CampaignCreate, CampaignUpdate } from '../services';

export type GetCampaignsFilters = { search?: string; status?: string };
export type GetCampaignMonitoringFilters = {
  search?: string;
  campaignId?: string;
  latest_contact_state_enum?: string;
};
export type CampaignCreatePayload = CampaignCreate;
export type CampaignUpdatePayload = CampaignUpdate;

export const getCampaigns = (
  filters: GetCampaignsFilters,
  page: ApiPaginationType
) => {
  return AdminApiService.getCampaignsApiAdminCampaignsGet(
    filters.status,
    page.limit,
    page.offset
  );
};

export const getCampaignMonitoring = (
  filters: GetCampaignMonitoringFilters
) => {
  return AdminApiService.getCampaignMonitoringApiAdminCampaignMonitoringGet(
    filters.campaignId
  );
};

export const getCampaignMetrics = (filters: GetCampaignMonitoringFilters) => {
  return AdminApiService.getCampaignMetricsApiAdminCampaignMetricsGet(
    filters.campaignId
  );
};

export const addCampaign = (payload: CampaignCreatePayload) => {
  return AdminApiService.createCampaignApiAdminCampaignsPost(payload);
};
export const updateCampaign = (id: string, payload: CampaignUpdatePayload) => {
  return AdminApiService.updateCampaignApiAdminCampaignsCampaignIdPatch(
    id,
    payload
  );
};
export const deleteCampaign = (id: string) => {
  return AdminApiService.deleteCampaignApiAdminCampaignsCampaignIdDelete(id);
};

export type { CampaignResponse as CampaignType } from '../services';
export type { CampaignMonitoringResponse as CampaignMonitoringItemType } from '../services';
